export default "__VITE_ASSET__t1zkn7Vv__"